var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeliverShip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bd6d4fc1-f2b2-4c33-8c43-e431fded88a1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".e5fb6e09-ff1e-4201-8a55-6295a1d06af4,.f791f07d-d035-4d18-9db2-b48fc22fc4c5{fill:none;}.f791f07d-d035-4d18-9db2-b48fc22fc4c5{clip-rule:evenodd;}.b5d043e0-d351-4e3b-8389-4e83461900e0{clip-path:url(#f11022b0-f365-43f1-a318-6292c6ead485);}.b0374cb3-99e9-4971-a07f-69b5f82e3793{fill:#d8d8d8;}.b241478d-4a92-402b-8152-6999d5a1b6d1{clip-path:url(#b9542aec-6549-44dc-a707-601ad82d09d2);}.f30ee4a8-2a14-4b4e-997c-8260b9c57608{clip-path:url(#b05841fe-c01b-42fe-a01e-307ea6d9a25a);}.b18f1db3-e6d3-46f5-92dd-455a1a2d8704{clip-path:url(#b04ad9c5-e49d-439a-bb1e-e459c192bfc3);}.ab7f50b8-0e3c-4a8e-a394-fd0be537e86e{clip-path:url(#a4be38b0-39ed-4558-b2db-06aae3bffec6);}.bf9c37e1-9521-4505-91f5-6c7baa315a44{clip-path:url(#af523a7b-bb91-4c1f-8aad-fad9514bf206);}.b9b728e7-2668-4abc-bacd-cdcf25ae042a{clip-path:url(#aaa5ec26-6a78-4b72-8715-cf4ff22c0587);}.b49ce1b4-a955-4455-89e7-4728b69e37b4{clip-path:url(#ed2b50f7-b0fb-4652-b91e-2a2edd55e8a8);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "f11022b0-f365-43f1-a318-6292c6ead485"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f791f07d-d035-4d18-9db2-b48fc22fc4c5",
    d: "M17.73-6.53H6.35l-.61,1H18.3ZM7.65-8.47,7-7.37H17.1l-.72-1.1h1.51l3.16,4.66h-1.5l-.62-.87H5.08l-.57.87H3.05L6.24-8.47Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b9542aec-6549-44dc-a707-601ad82d09d2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e5fb6e09-ff1e-4201-8a55-6295a1d06af4",
    x: 8.45,
    y: 5.79,
    width: 2.02,
    height: 1.01
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b05841fe-c01b-42fe-a01e-307ea6d9a25a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e5fb6e09-ff1e-4201-8a55-6295a1d06af4",
    x: 13.49,
    y: 5.79,
    width: 2.02,
    height: 1.01
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b04ad9c5-e49d-439a-bb1e-e459c192bfc3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e5fb6e09-ff1e-4201-8a55-6295a1d06af4",
    x: 10.97,
    y: 5.79,
    width: 2.02,
    height: 1.01
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a4be38b0-39ed-4558-b2db-06aae3bffec6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f791f07d-d035-4d18-9db2-b48fc22fc4c5",
    d: "M11.12,2.7h1.76V1.16c0-.18-.12-.27-.35-.27H11.37c-.17,0-.25.09-.25.27Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "af523a7b-bb91-4c1f-8aad-fad9514bf206"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f791f07d-d035-4d18-9db2-b48fc22fc4c5",
    d: "M7.49,5h9v-1a.23.23,0,0,0-.26-.26H7.72c-.16,0-.23.08-.23.26Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aaa5ec26-6a78-4b72-8715-cf4ff22c0587"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f791f07d-d035-4d18-9db2-b48fc22fc4c5",
    d: "M7.42,5.79v1.6c0,.21.12.31.35.31h8.41a.27.27,0,0,0,.31-.31V5.79h1.77q.51,0,.51.39V7.85c0,1.38-1.28,1.38-1.28,2.88L12,8.59,6.46,10.81c0-1.53-1.28-1.53-1.28-3V6.13c0-.23.12-.34.36-.34Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ed2b50f7-b0fb-4652-b91e-2a2edd55e8a8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f791f07d-d035-4d18-9db2-b48fc22fc4c5",
    d: "M7.71,12.94A1.1,1.1,0,1,0,8.81,14,1.09,1.09,0,0,0,7.71,12.94Zm4.78-3.18,9.1,3.62c.17.07.22.23.13.46l-3.16,8.3q-.89-1.37-4,.48c-3.12,1.85-2-2.28-5-.48q-3,1.8-4,0L2.28,13.81a.3.3,0,0,1,.18-.45q.33-.15,9-3.6v7.12c0,.22.1.33.31.33h.37c.21,0,.31-.11.31-.33Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b5d043e0-d351-4e3b-8389-4e83461900e0"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b0374cb3-99e9-4971-a07f-69b5f82e3793",
    x: -1.95,
    y: -13.47,
    width: 28,
    height: 14.65
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "b241478d-4a92-402b-8152-6999d5a1b6d1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b0374cb3-99e9-4971-a07f-69b5f82e3793",
    x: 3.45,
    y: 0.79,
    width: 12.02,
    height: 11.01
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "f30ee4a8-2a14-4b4e-997c-8260b9c57608"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b0374cb3-99e9-4971-a07f-69b5f82e3793",
    x: 8.49,
    y: 0.79,
    width: 12.02,
    height: 11.01
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "b18f1db3-e6d3-46f5-92dd-455a1a2d8704"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b0374cb3-99e9-4971-a07f-69b5f82e3793",
    x: 5.97,
    y: 0.79,
    width: 12.02,
    height: 11.01
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "ab7f50b8-0e3c-4a8e-a394-fd0be537e86e"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b0374cb3-99e9-4971-a07f-69b5f82e3793",
    x: 6.12,
    y: -4.11,
    width: 11.76,
    height: 11.81
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "bf9c37e1-9521-4505-91f5-6c7baa315a44"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b0374cb3-99e9-4971-a07f-69b5f82e3793",
    x: 2.49,
    y: -1.33,
    width: 19,
    height: 11.3
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "b9b728e7-2668-4abc-bacd-cdcf25ae042a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b0374cb3-99e9-4971-a07f-69b5f82e3793",
    x: 0.18,
    y: 0.79,
    width: 23.59,
    height: 15.02
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "b49ce1b4-a955-4455-89e7-4728b69e37b4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b0374cb3-99e9-4971-a07f-69b5f82e3793",
    x: -2.76,
    y: 4.76,
    width: 29.53,
    height: 23.35
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliverShip);
export default __webpack_public_path__ + "static/media/deliver-ship.2d6d9efdf6c69a3beaf44f857da372c0.svg";
export { ForwardRef as ReactComponent };